import React from 'react';
import { connect } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import { compose } from 'redux';
import { withRouter } from 'react-router-dom';
import { BackToPrev } from 'components/ui/index';
import { getThemeByType } from 'utils/common';
import SearchAccount from '../components/SearchAccount';
import SearchResults from '../components/SearchResults';
import AttachAction from '../components/AttachAction';
import { fetchOpportunitiesDetail, patchAttachAccount, reset } from '../flow/action';

class AttachAccount extends React.Component {
  componentDidMount() {
    const { fetchOpportunitiesDetail, match } = this.props;
    const { objectId } = match.params;
    fetchOpportunitiesDetail(objectId);
  }

  componentWillUnmount() {
    const { reset } = this.props;
    reset();
  }

  render() {
    const { match, selectedAccountId, patchAttachAccount } = this.props;
    const { objectType, objectId } = match.params;
    const theme = getThemeByType(objectType);

    return (
      <React.Fragment>
        <BackToPrev
          backText={<FormattedMessage id="page.AttachAccount.backToEditOpportinity" />}
          backLink={`/${objectType}/${objectId}`}
        />
        <SearchAccount
          theme={theme}
        />
        <SearchResults
          theme={theme}
        />
        <AttachAction
          objectType={objectType}
          objectId={objectId}
          theme={theme}
          selectedAccountId={selectedAccountId}
          patchAttachAccount={patchAttachAccount}
        />
      </React.Fragment>
    );
  }
}

const mapStateToProps = ({ global, clientDetails }) => ({
  lang: global.language,
  selectedAccountId: clientDetails.attachAccount.selectedAccountId,
});

const mapDispatchToProps = {
  fetchOpportunitiesDetail,
  patchAttachAccount,
  reset
};

const Enhancer = compose(
  withRouter,
  connect(mapStateToProps, mapDispatchToProps)
);

export default Enhancer(AttachAccount);



// WEBPACK FOOTER //
// ./src/views/AttachAccount/container/index.jsx